import StoreMarker from './StoreMarker';
import { type Store } from './types';

type Props = {
  stores: Store[];
};

const StoresMarkers: React.FC<Props> = ({ stores }) => {
  return (
    <>
      {stores.map((x) => (
        <StoreMarker key={x.id} store={x} />
      ))}
    </>
  );
};

export default StoresMarkers;
